import { render } from "./ProductoDetalle.vue?vue&type=template&id=3f3bde54"
import script from "./ProductoDetalle.vue?vue&type=script&lang=js"
export * from "./ProductoDetalle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__